import React, { useRef, useState, useEffect } from 'react'
import { View, TouchableOpacity } from 'react-native'
import PropTypes from 'prop-types'

import { VFInput, VFText, Icon, VFButton } from '@vfgroup-oneplatform/foundation/Components'

import { Images, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import RadioGroup from '../RadioGroup'
import Error from '../Error'

import { Images as images } from '../../Themes'

import styles from './Sim.Styles'


const Sim = ({
  accountNumber,
  currentIndex,
  changeCurrentIndex,
  availableSims,
  selectedSimNumber,
  setSelectedSimNumber,
  resourcesLoading,
  resourcesError,
  getAvaliableResources,
  theme,
}) => {

  const numberRef = useRef()

  const [number, setNumber] = useState('')

  const formatNumber = (number) => { //003556 +3556
    if (number.startsWith('355')) {
      return number
    } else {
      if (number.startsWith('06')) {
        return number?.replace('06', '3556')
      } else if (number.startsWith('6')) {
        return number?.replace('6', '3556')
      } else if (number.startsWith('003556')) {
        return number?.replace('003556', '3556')
      } else if (number.startsWith('+3556')) {
        return number?.replace('+3556', '3556')
      } else if (number.startsWith('+355')) {
        return number?.replace('+355', '355')
      } else {
        return number
      }
    }
  }

  const getData = () => {
    getAvaliableResources({
      'searchedNumber': formatNumber(number),
      'accountNumber': accountNumber
    })
  }

  const tryAgain = () => {
    setNumber('')
    numberRef.current.state.text = ''
    numberRef.current.blur()
    getAvaliableResources({
      'searchedNumber': '35569',
      'accountNumber': accountNumber
    })
  }

  useEffect(() => {
    setSelectedSimNumber('')
  }, [])


  return (
    <View>
      <View>
        <VFText
          i18nKey="acquisition_sim_step_title"
          style={styles.stepTitle}
        />
        <VFText
          i18nKey="acquisition_sim_step_subtitle"
          style={styles.stepDesc(theme)}
        />
      </View>
      <>
        <View style={styles.searchContainer}>
          <VFInput
            fieldRef={ref => {
              numberRef.current = ref
            }}
            label="acquisition_sim_step_choose_number"
            value={number}
            onChangeText={(el) => {
              setNumber(el)
              setSelectedSimNumber('')
            }}
            tintColor={theme.colors.textInput.default.tintColor}
            baseColor={theme.colors.textInput.default.baseColor}
            showRightIcon={!!number}
            rightIconName={Images.ic_close}
            rightIconPress={() => {
              setNumber('')
              numberRef.current.state.text = ''
            }}
            containerStyle={styles.searchInput}
            labelTextStyle={styles.inputText(theme)}
            style={styles.inputText(theme)}
            keyboardType="phone-pad"
          />
          <View style={styles.line(theme)} />
          <TouchableOpacity
            style={styles.searchIcon(!!number)}
            onPress={getData}
            activeOpacity={1}
          >
            <Icon
              name={images.search}
              type="image"
              size={40}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>

        {resourcesError ? <Error
          error={'acquisition_resources_error'}
          onPress={tryAgain}
        /> : <RadioGroup
          options={resourcesLoading ? [{}, {}, {}] : availableSims}
          selected={selectedSimNumber}
          setSelected={setSelectedSimNumber}
          style={styles.radioGroupContainer}
          isLoading={resourcesLoading}
          theme={theme}
        />}

        <VFButton
          title="acquisition_continue"
          onPress={() => changeCurrentIndex(currentIndex + 1)}
          style={styles.continueButton}
          disabled={!selectedSimNumber}
        />
      </>
    </View>
  )
}
Sim.propTypes = {
  accountNumber: PropTypes.string,
  currentIndex: PropTypes.number,
  changeCurrentIndex: PropTypes.func,
  availableSims: PropTypes.array,
  selectedSimNumber: PropTypes.string,
  setSelectedSimNumber: PropTypes.func,
  resourcesLoading: PropTypes.bool,
  resourcesError: PropTypes.string,
  getAvaliableResources: PropTypes.func,
}

export default withTheme(Sim)
